import { Link } from 'react-router-dom';
import logo from "../../img/logo2.png"

// Navbar & Hero Start
const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top px-lg-5 custom-navbar">
      <div className="container-fluid">
        {/* Enhanced Logo Section */}
        <Link to="/" className="navbar-brand ms-4 ms-lg-0 d-flex align-items-center">
          <div className="logo-wrapper me-3 position-relative">
            <img src={logo} className="logo img-fluid" alt="Outlook Digital Solutions Logo"/>
            {/* Animated Ring Effect */}
            <div className="logo-ring"></div>
          </div>
          <div className="brand-text text-start">
            <h2 className="mb-0 text-white fw-bold brand-title gradient-text  txxt">
              OUTLOOK
            </h2>
         
              <small className="text-light slogan-text txxt ">
         Digital Solutions
              </small>
              <div className="slogan-underline"></div>
            
          </div>
        </Link>

        {/* Mobile Toggle */}
        <button 
          type="button" 
          className="navbar-toggler custom-toggler me-4" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Menu */}
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav mx-auto p-4 p-lg-0">
            <Link to="/" className="nav-item nav-link nav-link-enhanced">
              <i className="fas fa-home me-2"></i>Home
            </Link>
            <Link to="/about" className="nav-item nav-link nav-link-enhanced">
              <i className="fas fa-info-circle me-2"></i>About
            </Link>
            <Link to="/service" className="nav-item nav-link nav-link-enhanced">
              <i className="fas fa-cogs me-2"></i>Services
            </Link>
            <Link to="/products" className="nav-item nav-link nav-link-enhanced">
              <i className="fas fa-box me-2"></i>Products
            </Link>
            <div className="nav-item dropdown">
              <Link 
                to="" 
                className="nav-link dropdown-toggle nav-link-enhanced" 
                data-bs-toggle="dropdown"
              >
                <i className="fas fa-building me-2"></i> Company
              </Link>
              <div className="dropdown-menu m-0 bg-dark-card border-light">
                <Link to="" className="dropdown-item text-light">
                  <i className="fas fa-handshake me-2"></i>Partnerships
                </Link>
                <Link to="/history" className="dropdown-item text-light">
                  <i className="fas fa-rocket me-2"></i>History
                </Link>
              </div>
            </div>
            <Link to="/contact" className="nav-item nav-link nav-link-enhanced">
              <i className="fas fa-envelope me-2"></i>Contact
            </Link>
          </div>

          {/* Social Media Icons */}
          <div className="d-none d-lg-flex align-items-center">
            <a className="btn btn-sm-square btn-primary me-2 social-btn" href="https://wa.me/+201205450008">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a className="btn btn-sm-square btn-primary me-2 social-btn" href="https://www.facebook.com/share/1DJdbQXfGv/?mibextid=wwXIfr">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a className="btn btn-sm-square btn-primary me-2 social-btn" href="https://www.linkedin.com/company/outlookds/">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a className="btn btn-sm-square btn-primary social-btn" href="https://www.instagram.com/outlook_ds?igsh=MXdmbm03bWxteDJkbw==">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;